// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import type { Reducers } from '../reducers';
import type { Project } from '../auth/with-project-context';
import type { ActivityDetailState } from './reducer';
import CustomModal from '../components/custom-modal';

import ActionTypes from './action-types';
import ActivityDetail from './activity-detail';

import withProjectContext from '../auth/with-project-context';

type Props = {
  activityId: number,
  activityName: string,
  delayType: string,
  project: Project,
  dispatch: Object => mixed,
  data: ActivityDetailState,
};

class ActivityDetailContainer extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch({
      type: ActionTypes.GET_ACTIVITY_DETAIL,
      data: {
        activityId: this.props.activityId,
        projectId: this.props.project.id,
        delayType: this.props.delayType,
      },
    });
  }

  componentWillUnmount() {
    this.props.dispatch({ type: ActionTypes.CLEAR_ACTIVITY_DETAIL });
  }

  closeModal = () => {
    this.props.dispatch({
      type: 'hideModal',
    });
  }

  render(): React.Node {
    return (
      <CustomModal onClose={this.closeModal}>
        <ActivityDetail activity={this.props.data.activity} activityName={this.props.activityName} />
      </CustomModal>
    );
  }
}

const Component: any = compose(
  connect((state: Reducers): { data: Object } => ({ data: state.activityDetail })),
  withProjectContext,
)(ActivityDetailContainer);

export default Component;
